import request from '@/utils/request'
import { getCMSUrl } from './config'

type dataType = any

export default {
    // 获取策略类别
    getCategoryList(data?: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: getCMSUrl + '/strategy/category_list',
            method: 'get',
            data,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },

    // 获取策略列表
    getStrategyList(data?: { token?: string; type?: string | number; category?: string | number }): Promise<{
        response?: Response
    }> {
        const params = new URLSearchParams()
        if (data) Object.keys(data).forEach(key => params.append(key, (data as any)[key]))
            console.log('getStrategyList',params)
        return request({
            url: getCMSUrl + '/strategy/list',
            method: 'post',
            data: params,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },

    // 获取策略历史调仓记录
    getStockHistory(data: {
        token: string
        code: string
        sortField?: string
        sortType?: 'asc' | 'desc'
        pageNo?: number
        pageSize?: number
    }): Promise<{ response?: Response }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, String((data as any)[key])))
        return request({
            url: getCMSUrl + '/strategy/stock_history',
            method: 'post',
            data: params,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },

    // 策略收藏 / 取消收藏
    favoriteStrategy(data: {
        token: string
        code: string
        status: 0 | 1  // 1收藏 0取消收藏
    }): Promise<{ response?: Response }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, String((data as any)[key])))
        return request({
            url: getCMSUrl + '/strategy/favorite',
            method: 'post',
            data: params,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },

    // 获取策略持仓股票
    getStockTrack(data: {
        token: string
        code: string
    }): Promise<{ response?: Response }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, String((data as any)[key])))
        return request({
            url: getCMSUrl + '/strategy/stock_track',
            method: 'post',
            data: params,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    },

    // 获取策略累计收益曲线
    getCumulative(data: {
        token: string
        code: string
        timePeriod: '1' | '2' | '3' | '4'  // 1:近3月 2:近1年 3:今年以来 4:全部
    }): Promise<{ response?: Response }> {
        const params = new URLSearchParams()
        Object.keys(data).forEach(key => params.append(key, String((data as any)[key])))
        return request({
            url: getCMSUrl + '/strategy/cumulative',
            method: 'post',
            data: params,
            headers: {
                'clienttype': 'pc',
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    }
}
